import { Controller } from "@hotwired/stimulus";

// Enables a submit button only when an input contains the exact word "CONFIRM".
// Targets:
//   input  – the text field the user types into
//   button – the submit button to enable/disable
export default class extends Controller {
  static targets = ["input", "button"];

  connect() {
    this.toggle();
  }

  toggle() {
    const confirmed = this.inputTarget.value.trim() === "CONFIRM";
    this.buttonTarget.disabled = !confirmed;
  }
}
